// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-spin input[type=number]{-moz-appearance:textfield}.drag-header{padding:0;height:36px!important;border-right:thin solid rgba(0,0,0,.12)}", ""]);
// Exports
module.exports = exports;
